export default __webpack_public_path__ + "static/media/HeadphoneSidenav.dcee5376.svg";